<div class="login-wrapper">
   <!--  <form class="login">-->
   <samweb-loading-indicator
      fxFlexFill
      [longRunningContextCategories]="['AUTHENTICATION']"
      [runForever]="false"
      [formGroupsToHandle]="[signInForm]"
   >
      <form class="k-form" [formGroup]="signInForm" (ngSubmit)="signMeIn()">
         <section class="title">
            <div fxLayout="row" fxLayoutAlign="center center">
               <img
                  src="../../../assets/img/sam.hollow.pink.svg"
                  class="sam-login-logo"
                  border="0"
                  width="128px"
                  height="128px"
               />
               <div class="application-name">
                  <span class="application-name-web">Web</span><br />
                  <span class="application-name-agent">Agent</span>
               </div>
            </div>
         </section>

         <div class="k-form-field">
            <input
               samwebAutoFocus
               name="username"
               formControlName="userName"
               kendoTextBox
               autocomplete="username"
               required
               placeholder="{{ 'common.authentication.username' | translate }}"
            />
         </div>
         <div class="k-form-field">
            <input
               kendoTextBox
               type="password"
               name="password"
               formControlName="password"
               autocomplete="current-password"
               placeholder="{{ 'common.authentication.password' | translate }}"
            />
         </div>

         <button
            type="submit"
            class="login-button-container"
            kendoButton
            [primary]="true"
            [disabled]="!signInForm.valid"
         >
            <div class="sam-button-text">
               {{ 'common.authentication.sign_in_label' | translate }}
            </div>
         </button>

         <button
            type="button"
            class="microsoft-button-container"
            kendoButton
            [secondary]="true"
            (click)="onMicrosoftSignInButtonClicked()"
            *ngIf="useMicrosoftEntraIdAuthentication$ | async"
            [disabled]="signInForm.disabled"
         >
            <fa-icon [icon]="microsoftIcon.icon"></fa-icon>
            {{ 'common.authentication.sign_in_microsoft_label' | translate }}
         </button>

         <div class="login-error k-block k-error-colored" *ngIf="showError$ | async">
            <div>
               <fa-icon [icon]="errorIcon$ | async"></fa-icon>
            </div>
            <div>
               {{ errorText$ | async | translate }}
               <br />
               <a
                  class="microsoft-sign-out-link"
                  [routerLink]=""
                  (click)="onMicrosoftSignOutButtonClicked()"
                  *ngIf="
                     (useMicrosoftEntraIdAuthentication$ | async) && (wasMicrosoftEntraIdAuthenticationAttempt$ | async)
                  "
                  >{{ 'common.authentication.sign_out_microsoft_label' | translate }}</a
               >
            </div>
         </div>
      </form>
   </samweb-loading-indicator>
</div>
